import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "exp_month": {
      "column": null,
      "name": "exp_month",
      "selected_by_default": null,
      "translated": null
    },
    "exp_year": {
      "column": null,
      "name": "exp_year",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "masked_number": {
      "column": null,
      "name": "masked_number",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripePaymentMethod",
  "collectionKey": "stripe_payment_methods",
  "collectionName": "stripe_payment_methods",
  "i18nKey": "stripe_payment_method",
  "camelizedLower": "stripePaymentMethod",
  "name": "StripePaymentMethod",
  "nameDasherized": "stripe-payment-method",
  "pluralName": "stripe_payment_methods",
  "ransackable_associations": [
    {
      "className": "Account",
      "collectionName": "accounts",
      "foreignKey": "stripe_customer_id",
      "name": "account",
      "macro": "has_one",
      "resource_name": "Account",
      "through": "stripe_customer"
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "customer",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripePaymentIntent",
      "collectionName": "stripe_payment_intents",
      "foreignKey": "payment_method",
      "name": "stripe_payment_intents",
      "macro": "has_many",
      "resource_name": "StripePaymentIntent",
      "through": null
    },
    {
      "className": "StripeSetupIntent",
      "collectionName": null,
      "foreignKey": "payment_method",
      "name": "stripe_setup_intents",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "billing_details",
      "column": {
        "default": null,
        "name": "billing_details",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "card",
      "column": {
        "default": null,
        "name": "card",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "customer",
      "column": {
        "default": null,
        "name": "customer",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": null,
        "name": "livemode",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "stripe_type",
      "column": {
        "default": null,
        "name": "stripe_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "stripe_payment_method",
  "primaryKey": "id"
}

/** Frontend model for StripePaymentMethod. */
class StripePaymentMethod extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  expMonth() {
    return this.readAttributeUnderscore("exp_month")
  }

  /** @returns {boolean} */
  hasExpMonth() {
    const value = this.expMonth()

    return this._isPresent(value)
  }

  /** @returns {any} */
  expYear() {
    return this.readAttributeUnderscore("exp_year")
  }

  /** @returns {boolean} */
  hasExpYear() {
    const value = this.expYear()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  maskedNumber() {
    return this.readAttributeUnderscore("masked_number")
  }

  /** @returns {boolean} */
  hasMaskedNumber() {
    const value = this.maskedNumber()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }
}

export default StripePaymentMethod
